import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import NavTop from './sfc/navtop'
import * as billTopperStyles from '../styles/project-modules/billtopper.module.less'
import * as topperStyles from '../styles/modules/topper.module.less'
import SafeLink from './sfc/safelink'
import ReporterComment from './bills/ReporterComment'
import { convertDatesToAP } from './sfc/component-helpers/datehelpers'
import storySettings from '../data/story_settings.sheet.json'
import {
  dead_bill_explanation,
  merged_bill_explanation
} from '../data/LegisTracker_all_states_text.json'

const BillTopper = ({
  meta,
  Title,
  Deck,
  kicker,
  url_add,
  updated,
  bill_link,
  reporter_comment,
  reporter_credit,
  publicationName,
  yourLegislators,
  setYourLegislators,
  dead_bill=false,
  merged_bill=false
}) => {
  const mod_date = new Date(updated.replace(/-/g, "/"))
  const ISO_MODDATE = mod_date.toISOString()
  const moddateString = convertDatesToAP(
    mod_date.toLocaleString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    })
  )
  const {Market_Key} = storySettings[0];


  //TO DO: ADJUST ISO_MODDATE

  return (
    <Fragment>
      <NavTop meta={meta} url_add={url_add} />
      <header className={billTopperStyles.header}>
        <section
          aria-label="BillTopper headline, deck, byline and dateline"
          className={billTopperStyles.textContainer}
        >
          <div>
            <h1 className={billTopperStyles.kicker} >{kicker}</h1>
            {dead_bill && <h1 className={`${billTopperStyles.kicker} ${billTopperStyles.deadBillIcon}`}>DEAD</h1>}
            {merged_bill && <h1 className={`${billTopperStyles.kicker} ${billTopperStyles.deadBillIcon}`}>MERGED</h1>}
          </div>
          <h1 className={billTopperStyles.hed}>
            {Title}
          </h1>
          <div className={topperStyles.dateby}>
            {updated && (
              <Fragment>
                <time
                  className="BillTopper-dateline updated-date"
                  dateTime={ISO_MODDATE}
                  itemProp="dateModified"
                >
                  Updated {moddateString}
                </time>
              </Fragment>
            )}
          </div>
          <h2 className={billTopperStyles.dek} dangerouslySetInnerHTML={{__html: Deck}} />
<h2 className={billTopperStyles.dek}>
            {bill_link && (
              <SafeLink href={bill_link} withinSite={false}>
                Find the bill's full text and more information here.
              </SafeLink>
            )}
          </h2>
          {dead_bill && <h2 className={`${billTopperStyles.dek} ${billTopperStyles.deadBill}`}>{dead_bill_explanation}</h2>}
          {merged_bill && <h2 className={`${billTopperStyles.dek} ${billTopperStyles.mergedBill}`}>{merged_bill_explanation}</h2>}
          {reporter_comment && (
            <ReporterComment
              publicationName={publicationName}
              comment={reporter_comment}
              reporter={reporter_credit}
            />
          )}
           <a href="../">← Return to main page.</a>
        </section>
      </header>
    </Fragment>
  )
}

BillTopper.propTypes = {
  meta: PropTypes.object.isRequired,
}

export default BillTopper
